module.exports = __webpack_public_path__ + "static/media/reg-temp-job.cc7221c0.svg";